// extracted by mini-css-extract-plugin
export var contrastLow = "_l-1";
export var externalLink = "_l-2";
export var externalLinkIcon = "_l-3";
export var link = "_l-0";
export var linkLabel = "_l-4";